// utils/api.js

// Function to get reCAPTCHA token
const getReCaptchaToken = async (action) => {
  try {
    if (typeof window !== 'undefined' && window.grecaptcha) {
      const token = await window.grecaptcha.execute('6LfWqXkrAAAAALuvKV2hi5wCqN4dpo0jhpzPHcg1', { action });
      return token;
    }
    throw new Error('reCAPTCHA not loaded');
  } catch (error) {
    console.error('Error getting reCAPTCHA token:', error);
    throw error;
  }
};

// Function to track Google Analytics events
const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

export const submitEmailToAPI = async (email) => {
  try {
    // Get reCAPTCHA token
    const recaptchaToken = await getReCaptchaToken('subscribe');
    
    const response = await fetch('/api/subscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        email: email,
        recaptchaToken: recaptchaToken 
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    // Track successful subscription
    trackEvent('email_subscription', {
      'method': 'landing_page'
    });
    
    return { success: true, data };
  } catch (error) {
    console.error('Error subscribing email:', error);
    
    // Track subscription failure
    trackEvent('subscription_failed', {
      'error_type': error.message.includes('reCAPTCHA') ? 'recaptcha_failed' : 'api_error'
    });
    
    return { success: false, error: error.message };
  }
};

export const submitUnsubscribeToAPI = async (email) => {
  try {
    // Get reCAPTCHA token
    const recaptchaToken = await getReCaptchaToken('unsubscribe');
    
    const response = await fetch('/api/unsubscribe', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        email: email,
        recaptchaToken: recaptchaToken 
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    // Track successful unsubscription
    trackEvent('email_unsubscription', {
      'method': 'unsubscribe_page'
    });
    
    return { success: true, data };
  } catch (error) {
    console.error('Error unsubscribing email:', error);
    
    // Track unsubscription failure
    trackEvent('unsubscription_failed', {
      'error_type': error.message.includes('reCAPTCHA') ? 'recaptcha_failed' : 'api_error'
    });
    
    return { success: false, error: error.message };
  }
};

export const submitContactToAPI = async (formData) => {
  try {
    // Get reCAPTCHA token
    const recaptchaToken = await getReCaptchaToken('contact');
    
    const response = await fetch('/api/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        phone: formData.phone || null,
        subject: formData.subject,
        message: formData.message,
        recaptchaToken: recaptchaToken
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    // Track successful contact form submission
    trackEvent('contact_form_submitted', {
      'contact_subject': formData.subject
    });
    
    return { success: true, data };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    
    // Track contact form failure
    trackEvent('contact_form_failed', {
      'error_type': error.message.includes('reCAPTCHA') ? 'recaptcha_failed' : 'api_error'
    });
    
    return { success: false, error: error.message };
  }
};